// AWS SES Configuration
import { SESClient } from "@aws-sdk/client-ses";

// NOTE: Exposing AWS Credentials in frontend code is a security risk.
// Best practice is to use Amazon Cognito or a backend proxy (Lambda/API Gateway).
// For this implementation, we are using variables from .env

export const AWS_CONFIG = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || '',
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || '',
  },
  sourceEmail: process.env.REACT_APP_AWS_SOURCE_EMAIL || 'contacto@unilearn.cl', // Verified email in SES
  destinationEmail: process.env.REACT_APP_AWS_DESTINATION_EMAIL || 'contacto@unilearn.cl'
};

export const sesClient = new SESClient({
  region: AWS_CONFIG.region,
  credentials: AWS_CONFIG.credentials
});
